'use client'

import { isEqual, noop } from 'lodash'
import { memo, ReactElement } from 'react'

import GridItemComponent from './GridItem'

type GridItem<T> = {
  id: number | string
  type?: string
  data: T
}

type ItemVisibleCallbackArgs<T> = {
  item: GridItem<T>
  index: number
}

type ItemGridProps<T> = {
  items: Array<GridItem<T>>
  renderItem: (item: GridItem<T>, index: number) => ReactElement | null
  widthResolver?: (item: GridItem<T>) => 'full-row' | 'one-fifth' | 'one-fourth' | null
  onItemVisible?: (callbackArgs: ItemVisibleCallbackArgs<T>) => void
}

/** @deprecated use custom grid implementation instead */
const Grid = <T,>({
  items,
  renderItem,
  widthResolver = () => null,
  onItemVisible = noop,
}: ItemGridProps<T>) => (
  <div className="feed-grid">
    {items.map((item, index) => (
      <GridItemComponent
        key={item.id}
        width={widthResolver(item)}
        onVisible={() => onItemVisible({ item, index })}
      >
        {renderItem(item, index)}
      </GridItemComponent>
    ))}
  </div>
)

// type assertion required for generics to work
export default memo(Grid, isEqual) as typeof Grid
